module.exports = __webpack_public_path__ + "img/channel-reason.03348f98.png";